import {
  FleetVehicleExpenseEditFormValues,
  FleetVehicleExpenseSearchFormValues,
} from "./types";

export const initialFleetVehicleExpenseSearchForm: FleetVehicleExpenseSearchFormValues =
  {
    search: "",
    expenseTypeId: null,
    expenseDateFrom: null,
    expenseDateTo: null,
    amountMin: null,
    amountMax: null,
    vehicleManufacturerId: null,
    vehicleModelId: null,
    vehicleTypeId: null,
  };

/** Vrsta troška koju predlaže čarobnjak premještaja — sistemska podgrupa „Transport vozila". */
export const EXPENSE_TYPE_VEHICLE_TRANSPORT = "3c05a1d0-0002-4c00-9a00-000000000010";

/**
 * Ikona po šifri vrste troška — vrste dolaze iz šifrarnika (naziv i šifra), a ovdje im se dodaje
 * ono što šifrarnik ne nosi, da se u popisu prepoznaju na prvi pogled. Nepoznata vrsta dobiva
 * zadanu ikonu.
 */
export const EXPENSE_TYPE_ICONS: Record<string, string> = {
  "FLEET-TRANS": "/media/icons/location.svg",
  "FLEET-SERVIS": "/media/icons/service.svg",
  "FLEET-GUME": "/media/icons/tire.svg",
  "FLEET-OSIG": "/media/icons/shield.svg",
  "FLEET-REG": "/media/icons/list-check.svg",
  "FLEET-OPREMA": "/media/icons/fire-extinguisher.svg",
  "FLEET-NABAVA": "/media/icons/vehicle.svg",
  "FLEET-NABAVA-POREZ": "/media/icons/finance.svg",
  "FLEET-GORIVO": "/media/icons/payment.svg",
  "FIN-KAMATE": "/media/icons/bank.svg",
  "OTHER-AMORT": "/media/icons/price.svg",
};

export const DEFAULT_EXPENSE_TYPE_ICON = "/media/icons/expense.svg";

export const initialFleetVehicleExpenseEditForm: FleetVehicleExpenseEditFormValues =
  {
    id: "",
    vehicleId: "",
    expenseTypeId: null,
    officeId: null,
    name: "",
    description: "",
    expenseDate: null,
    paymentDate: null,
    amount: null,
    taxAmount: null,
    files: [],
  };
